import PlainButtonAsLink from 'app/common/ui-next/plain-button-as-link/plain-button-as-link'
import { PlainConfirm } from 'app/common/ui-next/plain-confirm-modal'
import styles from './ActionButtonWithConfirm.module.scss'

type Props = {
  title: string
  disabled?: boolean
  confirmText: string
  onConfirm: () => Promise<boolean>
}

export const ActionButtonWithConfirm = ({
  title,
  disabled,
  confirmText,
  onConfirm,
}: Props) => {
  return (
    <PlainConfirm
      messageText={confirmText}
      onConfirm={onConfirm}
      closeRightAway
    >
      {beginConfirmation => (
        <PlainButtonAsLink
          onClick={beginConfirmation}
          disabled={disabled}
          linkClassName={styles.acceptBtn}
          type='button'
        >
          {disabled ? 'обработка...' : title}
        </PlainButtonAsLink>
      )}
    </PlainConfirm>
  )
}
